import * as tslib_1 from "tslib";
import { asRoughMs, isSingleDay, findElements, createElement, removeElement, getDayClasses, Component } from '@fullcalendar/core';
var TimelineHeader = /** @class */ (function (_super) {
    tslib_1.__extends(TimelineHeader, _super);
    function TimelineHeader(parentEl) {
        var _this = _super.call(this) || this;
        _this.parentEl = parentEl;
        return _this;
    }
    TimelineHeader.prototype.firstContext = function (context) {
        this.parentEl.appendChild(this.tableEl = createElement('table', {
            className: context.theme.getClass('tableGrid')
        }));
    };
    TimelineHeader.prototype.destroy = function () {
        removeElement(this.tableEl);
        _super.prototype.destroy.call(this);
    };
    TimelineHeader.prototype.render = function (props) {
        this.renderDates(props.tDateProfile);
    };
    TimelineHeader.prototype.renderDates = function (tDateProfile) {
        var _a = this.context, dateEnv = _a.dateEnv, theme = _a.theme;
        var cellRows = tDateProfile.cellRows;
        var lastRow = cellRows[cellRows.length - 1];
        var isChrono = asRoughMs(tDateProfile.labelInterval) > asRoughMs(tDateProfile.slotDuration);
        var oneDay = isSingleDay(tDateProfile.slotDuration);
        var html = '<colgroup>';
        // needs to be a col for each body slat. header cells will have colspans
        for (var i = tDateProfile.slotCnt - 1; i >= 0; i--) {
            html += '<col/>';
        }
        html += '</colgroup>';
        html += '<tbody>';
        for (var _i = 0, cellRows_1 = cellRows; _i < cellRows_1.length; _i++) {
            var rowCells = cellRows_1[_i];
            var isLast = rowCells === lastRow;
            html += '<tr' + (isChrono && isLast ? ' class="fc-chrono"' : '') + '>';
            for (var _b = 0, rowCells_1 = rowCells; _b < rowCells_1.length; _b++) {
                var cell = rowCells_1[_b];
                var headerCellClassNames = [theme.getClass('widgetHeader')];
                if (cell.isWeekStart) {
                    headerCellClassNames.push('fc-em-cell');
                }
                if (oneDay) {
                    headerCellClassNames = headerCellClassNames.concat(getDayClasses(cell.date, this.props.dateProfile, this.context, true) // adds "today" class and other day-based classes
                    );
                }
                html +=
                    '<th class="' + headerCellClassNames.join(' ') + '"' +
                        ' data-date="' + dateEnv.formatIso(cell.date, { omitTime: !tDateProfile.isTimeScale, omitTimeZoneOffset: true }) + '"' +
                        (cell.colspan > 1 ? ' colspan="' + cell.colspan + '"' : '') +
                        '>' +
                        '<div class="fc-cell-content">' +
                        cell.spanHtml +
                        '</div>' +
                        '</th>';
            }
            html += '</tr>';
        }
        html += '</tbody>';
        this.tableEl.innerHTML = html; // TODO: does this work cross-browser?
        this.slatColEls = findElements(this.tableEl, 'col');
        this.innerEls = findElements(this.tableEl.querySelector('tr:last-child'), // compound selector won't work because of query-root problem
        'th .fc-cell-text');
        findElements(this.tableEl.querySelectorAll('tr:not(:last-child)'), // compound selector won't work because of query-root problem
        'th .fc-cell-text').forEach(function (innerEl) {
            innerEl.classList.add('fc-sticky');
        });
    };
    return TimelineHeader;
}(Component));
export default TimelineHeader;
